module.exports = __webpack_public_path__ + "static/ethan_chun-d7651da861045c96e7744e5f23a6e36a.jpeg";